import type { RootState } from "../index";
import {
    TraceEvent,
    ADD_TRACE_EVENT,
    TRACING_SET_ENABLED,
    TRACING_CLEAR,
    AddTraceAction,
    SetTracingEnabledAction,
    ClearTracingAction,
} from "./types";

/**
 * Records a trace event into the store — gated on `tracing.enabled` so it is a no-op when tracing is off.
 * Each trace is stamped with a wall-clock `timestamp` (Event Log display) and a `performance.now()`
 * `perfTime` (correlation with profiling cycles).
 */
export function addTraceEvent(event: TraceEvent) {
    return (dispatch, getState: () => RootState) => {
        if (!getState().tracing?.enabled) return;

        dispatch({
            type: ADD_TRACE_EVENT,
            trace: { timestamp: new Date(), perfTime: performance.now(), event },
        } as AddTraceAction);
    };
}

export function setTracingEnabled(enabled: boolean) {
    return (dispatch) => {
        dispatch({ type: TRACING_SET_ENABLED, enabled } as SetTracingEnabledAction);
    };
}

export function clearTracing() {
    return (dispatch) => {
        dispatch({ type: TRACING_CLEAR } as ClearTracingAction);
    };
}
